import { graphql } from "../types";

export const GlobalSearchQuery = graphql(`
  query GlobalSearch(
    $searchQuery: String!
    $limitAccounts: Int!
    $limitUsers: Int!
  ) {
    __typename
    AccountsMsSearchAccounts(
      request: {
        filters: { query: $searchQuery }
        paging: { size: $limitAccounts }
      }
    ) {
      data {
        id
        number
        name
      }
      pagination {
        total
      }
    }
    AccountsMsSearchUsers(
      request: {
        filters: { query: $searchQuery }
        paging: { size: $limitUsers }
      }
    ) {
      data {
        id
        email
        firstName
        lastName
      }
      pagination {
        total
      }
    }
  }
`);
